import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  container: {
    padding: theme.spacing(2),
  },
  goalBox: {
    padding: theme.spacing(4),
    border: `1px solid ${theme.palette.grey[400]}`,
    borderRadius: 4,
  },
  actionBtn: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    alignSelf: 'center',
  },
  quillGrid: {
    '& .quill': {
      width: '100%',
    },
    '& .ql-container': {
      minHeight: '62px',
    },
    '& .ql-toolbar': {
      '& *': {
        tabIndex: -1,
      },
    },
    '& .ql-editor::before': {
      fontStyle: 'normal',
      fontFamily: '"Public Sans", sans-serif',
    },
  },
  description: {
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
  },
}));
